import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaTimes } from "react-icons/fa";
import CommonTable from "../../components/CommonTable/CommonTable";
import { URLS } from "../../Services/Constant";
import { get, post } from "../../Services/ApiHandler";
import "./PinCode.css";
import moment from "moment/moment";
import usePermission from "../../customHook/usePermission";
import StatusModal from "../../components/StatusModal/StatusModal";
import DateRange from "../../components/DateRange/DateRange";

const PinCode = () => {
    const location = useLocation();
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(location?.state?.page || 1);
    const [searchText, setSearchText] = useState("");
    const [totalCount, setTotalCount] = useState(0);
    const [pagination, setPagination] = useState(null);
    const [address, setAddress] = useState('')
    const [popup, setPopup] = useState(false);
    const navigate = useNavigate();
    const permission = usePermission();
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");


    const pageRef = useRef(page);

    useEffect(() => {
        pageRef.current = page;
    }, [page]);

    const persistPinCodeSelection = (date, pageNumber) => {
        if (date) {
            sessionStorage.setItem("pincodeSelectedDate", date);
        }
        if (pageNumber) {
            sessionStorage.setItem("pincodeSelectedPage", String(pageNumber));
        }
    };

    useEffect(() => {
        if (location?.state?.page) {
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, []);
    console.log("pageRef.current", pageRef.current);

    const handleView = async (row) => {
        console.log("ROW DATA:", row);

        if (row?.date) {
            persistPinCodeSelection(row?.date, pageRef.current);
            navigate("/pincode-view", {
                state: { date: row?.date, page: pageRef.current },
            });
        }
    };



    const columns = useMemo(() => {
        let d = [
            {
                Header: "S.No",
                accessor: "sno",
                disableSortBy: true,
                width: "1%",
                Cell: ({ row }) => {
                    return (
                        <span className="sno">
                            {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
                        </span>
                    );
                },
            },
            {
                Header: "Date",
                accessor: "date",
                width: "70%",
                Cell: ({ value }) => {
                    return <p className="mb-0">{value || "N/A"}</p>;
                },
            },
            {
                Header: "Over all User",
                accessor: "overall_user",
                width: "70%",
                Cell: ({ value }) => {
                    return <p className="mb-0">{value || "N/A"}</p>;
                },
            },

        ];



        let action = {
            Header: "Action",
            accessor: "action",
            disableSortBy: true,
            width: "20%",
            Cell: ({ row }) => {
                return (
                    <>
                        {permission?.includes("CAN-VIEW-USERS") && (
                            <button
                                className="action-btn"
                                onClick={() => handleView(row?.original)}
                            >
                                <FaEye />
                            </button>
                        )}
                    </>
                );
            },
        };

        return [...d, action];
    }, [page]);


    const fetchUsers = async () => {
        try {
            let res = await get(
                `${URLS.PINCODELIST}?page=${page || 1}&from_date=${fromDate || ""}&to_date=${toDate || ""}`
            );
            console.log("Users list res:", res);
            if (res?.status === "success") {
                setUsers(res?.data || []);
                setTotalCount(res?.count || 0);
                setPagination({
                    current_page: res?.current_page || 1,
                    last_page: res?.total_pages || 1,
                });
            }
        } catch (error) {
            console.error("Error fetching users:", error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [page, searchText, fromDate, toDate]);

    return (
        <>
            <PageHeader title="PinCode Management" />
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "20px",
                }}
            >
                <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
                    Total: {totalCount || 0}
                </h2>
                <DateRange
                    fromDate={fromDate}
                    toDate={toDate}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                />
            </div>
            <CommonTable
                columns={columns}
                data={users || []}
                pagecount={pagination}
                setPageno={setPage}
                pageno={page || 1}
            />
            <StatusModal isOpen={popup} onClose={() => setPopup(false)} message={address?.address} time={address?.last_click_update} />
        </>
    );
};

export default PinCode;
